import { Badge, Button, Group, Paper, PasswordInput, Text, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useKioskPinStatus, useSetKioskPin } from '@/api/kiosk';
import { useCurrentWorkspace } from '@/app/WorkspaceContext';
import { useApiError } from '@/hooks/useApiError';

/** Eigene Kiosk-PIN (KIO-04). */
export function KioskPinSection() {
  const { t } = useTranslation();
  const ctx = useCurrentWorkspace();
  const enabled = ctx.hasFeature('KIOSK');
  const onError = useApiError();
  const { data } = useKioskPinStatus(ctx.workspaceId, enabled);
  const setPin = useSetKioskPin(ctx.workspaceId);
  const [pin, setPinValue] = useState('');
  if (!enabled) return null;
  return (
    <Paper withBorder p="md">
      <Group justify="space-between" mb="xs">
        <Title order={5}>{t('kiosk.pinTitle')}</Title>
        <Badge color={data?.hasPin ? 'green' : 'gray'} variant="light">
          {data?.hasPin ? t('kiosk.pinSet') : t('kiosk.pinNotSet')}
        </Badge>
      </Group>
      <Text size="sm" c="dimmed" mb="sm">
        {t('kiosk.pinText', { workspace: ctx.workspace.name })}
      </Text>
      <Group align="flex-end">
        <PasswordInput
          label={t('kiosk.newPin')}
          value={pin}
          onChange={(e) => setPinValue(e.currentTarget.value.replace(/\D/g, '').slice(0, 6))}
          inputMode="numeric"
          w={180}
        />
        <Button
          disabled={pin.length < 4}
          loading={setPin.isPending}
          onClick={() =>
            setPin.mutate(pin, {
              onSuccess: () => {
                setPinValue('');
                notifications.show({ color: 'green', message: t('kiosk.pinSaved') });
              },
              onError,
            })
          }
        >
          {t('common.save')}
        </Button>
      </Group>
    </Paper>
  );
}
